import type { Capability } from '@taler/api-client'

/** Matches `SnapshotService`'s own read gate - list and detail, including a role that can
 * see history but not start or finish a session. */
export function canViewReconciliations(can: (capability: Capability) => boolean): boolean {
  return can('ACCOUNT_VIEW_BALANCES')
}

/** A reconciliation posts a financial record (RECORDS_MANAGE, same reasoning as loans and
 * contacts) and needs the recorded balance it corrects against (ACCOUNT_VIEW_BALANCES). */
export function canReconcile(can: (capability: Capability) => boolean): boolean {
  return can('RECORDS_MANAGE') && can('ACCOUNT_VIEW_BALANCES')
}
